/**
 * @generated SignedSource<<6a8421055208687085e532108435bf10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_item$data = {
  readonly defaultSkuId: string | null;
  readonly firstPhotoWebPath: string | null;
  readonly internalBuyLinks?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SharedRespLinksBlock_links">;
  } | null> | null;
  readonly isAuctionEnabled: boolean | null;
  readonly isSold: boolean | null;
  readonly isUnpurchasable: boolean | null;
  readonly itemIsOnHold: boolean | null;
  readonly seller?: {
    readonly isAccessible: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_seller" | "PdpRespSidebarSellerInfo_seller">;
  } | null;
  readonly serviceId: string | null;
  readonly skus: ReadonlyArray<{
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"KlarnaOnSiteMessage_sku" | "PdpRespDealerDetails_sku" | "PdpRespSidebarBlurbs_sku" | "PriceDisplay_sku">;
  } | null> | null;
  readonly storyTellingModule: {
    readonly tabs: ReadonlyArray<{
      readonly supplementaryEditorial: {
        readonly articles: ReadonlyArray<{
          readonly title: string;
        }> | null;
      } | null;
    } | null> | null;
  } | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"KlarnaOnSiteMessage_item" | "PdpRespAboutModule_item" | "PdpRespAboutTabs_item" | "PdpRespAuctionUrgencyInfo_item" | "PdpRespBreadcrumbs_item" | "PdpRespDealerDetails_item" | "PdpRespDetailsTabs_item" | "PdpRespHeroCarouselPrint_item" | "PdpRespHeroCarousel_item" | "PdpRespSellerItemTileCarousel_item" | "PdpRespSellerItemsCarousel_item" | "PdpRespSellerItems_item" | "PdpRespShippingReturns_item" | "PdpRespSidebarBlurbs_item" | "PdpRespSidebarButtons_item" | "PdpRespSidebarContact_item" | "PdpRespSidebarSellerInfoAndContactLazy_item" | "PdpRespSimilarAuctionItemsLazy_item" | "PdpRespSimilarItemsCarousel_item" | "PdpRespSimilarItemsFooter_item" | "PdpRespSimilarItemsLanding_item" | "PdpRespStorytellingModule_item" | "PdpRespSwatchSelector_item" | "PdpRespTitle_item" | "PdpRespTopModule_item" | "PdpRespYMALItemsCarousel_item" | "PdpSharedAuctionCountdownLazy_item" | "PdpSharedAuctionInfo_item" | "PdpSharedEditorialArticles_item" | "PdpSharedFramingStatus_item" | "PdpSharedQuantitySelect_item" | "PdpSharedRecentHistoryTracker_item" | "PdpSharedSidebarFavorites_item" | "PriceDisplay_item" | "SharedRespLinksBlock_item">;
  readonly " $fragmentType": "PdpRespContainer_item";
};
export type PdpRespContainer_item$key = {
  readonly " $data"?: PdpRespContainer_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v3 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v4 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v5 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = [
  {
    "kind": "Literal",
    "name": "hasSkuId",
    "value": true
  },
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchAuction"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    },
    {
      "kind": "RootArgument",
      "name": "hasRestyledProductTiles"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpRedesignVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "small"
        }
      ],
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": "firstPhotoWebPath(size:\"small\")"
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultSkuId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnpurchasable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": "itemIsOnHold",
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        }
      ],
      "kind": "ScalarField",
      "name": "isOnHold",
      "storageKey": null
    },
    {
      "condition": "fetchAuction",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespAuctionUrgencyInfo_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedAuctionInfo_item"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedEditorialArticles_item"
    },
    {
      "condition": "isPdpRedesignVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespStorytellingModule_item"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespBreadcrumbs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarouselPrint_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespTitle_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_item"
    },
    {
      "condition": "hasRestyledProductTiles",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSimilarItemsFooter_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSellerItemTileCarousel_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSellerItems_item"
        }
      ]
    },
    {
      "condition": "hasRestyledProductTiles",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespYMALItemsCarousel_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSimilarItemsCarousel_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSellerItemsCarousel_item"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedQuantitySelect_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedRecentHistoryTracker_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_item"
    },
    {
      "args": (v5/*: any*/),
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    },
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSwatchSelector_item"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedFramingStatus_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutModule_item"
    },
    {
      "condition": "isPdpRedesignVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespAboutTabs_item"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespTopModule_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetailsTabs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSidebarFavorites_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionCountdownLazy_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarAuctionItemsLazy_item"
    },
    {
      "args": (v5/*: any*/),
      "kind": "FragmentSpread",
      "name": "KlarnaOnSiteMessage_item"
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccessible",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSidebarSellerInfo_seller"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSidebarSellerInfoAndContactLazy_seller"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespHeroCarousel_item"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternalBuyLinkType",
          "kind": "LinkedField",
          "name": "internalBuyLinks",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SharedRespLinksBlock_links"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarSellerInfoAndContactLazy_item"
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        {
          "condition": "isMultiSku",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespDealerDetails_sku"
            },
            {
              "args": (v6/*: any*/),
              "kind": "FragmentSpread",
              "name": "PriceDisplay_sku"
            },
            {
              "args": (v6/*: any*/),
              "kind": "FragmentSpread",
              "name": "KlarnaOnSiteMessage_sku"
            }
          ]
        },
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarBlurbs_sku"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryTellingModule",
      "kind": "LinkedField",
      "name": "storyTellingModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoryTellingTab",
          "kind": "LinkedField",
          "name": "tabs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WordpressArticlesType",
              "kind": "LinkedField",
              "name": "supplementaryEditorial",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WordpressArticleType",
                  "kind": "LinkedField",
                  "name": "articles",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "61eab2b11e90eeede431eada52bdc09c";

export default node;
